import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down_ac47d40ea7546b098116658ed8393825",
  "use": "arrow-down_ac47d40ea7546b098116658ed8393825-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"arrow-down_ac47d40ea7546b098116658ed8393825\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h16v16H0z\" />\n        <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M8 9.062L12.735 4.5 14 5.719 8 11.5 2 5.719 3.265 4.5z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol